
import { Crown } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

interface GalleryHeaderProps {
  isPremium: boolean;
}

export function GalleryHeader({ isPremium }: GalleryHeaderProps) {
  const { language } = useLanguage();
  
  return (
    <>
      <div className="mb-8 animate-fade-down">
        <h1 className="text-3xl font-bold tracking-tight">
          {t('gallery.title', language)}
        </h1>
        <p className="text-muted-foreground mt-1">
          {t('gallery.subtitle', language)}
        </p>
      </div>

      {/* Premium Feature Banner (for non-premium users) */}
      {!isPremium && (
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6 flex items-center justify-between">
          <div className="flex items-center">
            <Crown className="h-5 w-5 text-amber-500 mr-3" />
            <p className="text-amber-800">
              {t('premium.upgradeToUploadPhotos', language) || 'Upgrade to Premium to upload and organize your baby\'s photos'}
            </p>
          </div>
          <Link to="/premium">
            <Button size="sm" className="bg-amber-500 hover:bg-amber-600">
              {t('index.premiumBenefits.upgradeToPremium', language)}
            </Button>
          </Link>
        </div>
      )}
    </>
  );
}
